// extracted by mini-css-extract-plugin
module.exports = {"textMargin":"ProposalFormContent_textMargin__oF8pG","image":"ProposalFormContent_image__83PE6","text":"ProposalFormContent_text__M_ou7"};